"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var Settings = require("./settings");
var constants_1 = require("../data/constants");
var platformToken = function () {
    return Settings.get("token", {}).platform_token;
};
var current = function () {
    if (constants_1.environment.cache["platformPromise"]) {
        return constants_1.environment.cache["platformPromise"];
    }
    if (constants_1.environment.cache["platform"]) {
        constants_1.environment.cache["platformPromise"] = Promise.resolve(constants_1.environment.cache["platform"]);
    }
    else {
        constants_1.environment.cache["platformPromise"] = Request
            .sendGet(constants_1.endpoints.api + "/platform", {}, (constants_1.environment["request"] || {})["headers"]);
    }
    return constants_1.environment.cache["platformPromise"]
        .then(function (p) {
        if (p) {
            constants_1.environment.cache["platform"] = p;
            Settings.set("locale", p["locale"]);
            Settings.set("token", Object.assign({}, Settings.get("token"), {
                platform_token: p["token"]
            }));
        }
        return p;
    });
};
exports.current = current;
var update = function (data) {
    return Request
        .sendPut(constants_1.endpoints.api + "/platform/" + platformToken(), data)
        .then(function (p) {
        constants_1.environment.cache["platform"] = p;
        return p;
    });
};
exports.update = update;
var updateSettings = function (data) {
    return update({ settings: JSON.stringify(data) });
};
exports.updateSettings = updateSettings;
var currency = function () {
    return (constants_1.environment.cache["platform"] || {}).currency;
};
exports.currency = currency;
//# sourceMappingURL=platform.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/platform.js
// module id = 857
// module chunks = 3